import { Controller } from "react-hook-form";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Link as MuiLink,
  Stack,
} from "@mui/material";
import { FormLabel, Input, Password } from "../../../../components";
import { SubmitButton } from "../../../SignUp/partials/SubmitButton";
import { Link } from "react-router-dom";
import { TErrors, useSignIn } from "../../hooks/useSignIn";

export const SignInForm = () => {
  const {
    errors,
    control,
    isSubmitting,
    isResendingVerificationEmail,
    onSubmit,
    resendVerificationEmail,
  } = useSignIn();

  return (
    <Box component="form" width="100%" onSubmit={onSubmit} noValidate>
      <Controller
        control={control}
        name="email"
        render={({ field, fieldState }) => (
          <FormControl
            error={fieldState.invalid}
            sx={{ width: "100%", mt: 2.5 }}
          >
            <FormLabel htmlFor="email">Email</FormLabel>
            <Input
              {...field}
              fullWidth
              disabled={isSubmitting}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              id="email"
              type="email"
              placeholder="Enter your email"
              autoComplete="username"
            />
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="password"
        render={({ field, fieldState }) => (
          <FormControl
            error={fieldState.invalid}
            sx={{ width: "100%", mt: 2.5 }}
          >
            <FormLabel htmlFor="password">Password</FormLabel>
            <Password
              {...field}
              fullWidth
              disabled={isSubmitting}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              id="password"
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </FormControl>
        )}
      />
      <Stack my={3}>
        <MuiLink
          component={Link}
          to="/forgot-password"
          alignSelf="flex-end"
          fontSize={14}
          fontWeight={600}
        >
          Forgot Password?
        </MuiLink>
      </Stack>
      <SubmitButton
        type="submit"
        disabled={isSubmitting}
        loading={isSubmitting}
      >
        Sign In
      </SubmitButton>

      {Object.entries(errors).map(([key, error]) => {
        if (!error) return null;

        if ((key as keyof TErrors) === "emailNotVerified") {
          return (
            <FormHelperText error key={key}>
              {error}
              <Button
                variant="text"
                loading={isResendingVerificationEmail}
                onClick={resendVerificationEmail}
              >
                resend the verification email
              </Button>
            </FormHelperText>
          );
        }

        return (
          <FormHelperText error key={key}>
            {error}
          </FormHelperText>
        );
      })}
    </Box>
  );
};
